import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppBar, Toolbar, Grid, IconButton, Drawer, List, ListItem, ListItemText, Typography, useMediaQuery } from '@mui/material' // Srini 07-01-25
import { withStyles } from '@material-ui/core/styles'
import MenuIcon from '@mui/icons-material/Menu' // Srini 07-01-25
import styles from './headerStyles'


import { reducerContext } from "../../../contextApi's/contextApi's"
import { mySipRegister } from '../../../helpers/mySipRegister'
import { refreshToken } from '../../../helpers/refreshToken'
import handleLogout from '../../../helpers/handleLogout' // Srini 07-01-25

import AgentName from './AgentName' // Srini 07-01-25
import SipStatus from './SipStatus' // Srini 07-01-25


const Header = ({ classes }) => {

    const navigate = useNavigate()
    const isSmallScreen = useMediaQuery('(max-width: 600px)') // Srini 07-01-25

    const { state, dispatch } = useContext(reducerContext)
    // import new state - 19/09/24 - dev srini
    const { isLoggedIn, agentPublishStatus } = state

    const [timeDiff, setTimeDiff] = useState(null)
    const [drawerOpen, setDrawerOpen] = useState(false) // Srini 07-01-25
    const [selectMenu, setSelectMenu] = useState(null) // Srini 07-01-25

    const departmentName = localStorage.getItem('departmentName') // Srini 07-01-25

    // useEffect(() => {
    //     if (isLoggedIn) {
    //         mySipRegister()
    //     }
    // }, [isLoggedIn])


    // useEffect(() => {
    //     const fetchToken = async () => {

    //         if (isLoggedIn) {
    //             const expTime = await refreshToken(dispatch, navigate)

    //             if (expTime) {
    //                 setTimeDiff(expTime)
    //             }
    //         }
    //         // reset refresh token time - 26/09/24 - devSrin
    //         else {
    //             setTimeDiff(null)
    //         }
    //     }

    //     fetchToken()

    // }, [isLoggedIn, dispatch])

    // useEffect(() => {
    //     let intervalId

    //     if (timeDiff) {
    //         intervalId = setInterval(() => {
    //             refreshToken(dispatch, navigate)
    //         }, timeDiff * 1000)
    //     }

    //     return () => {
    //         if (intervalId) {
    //             clearInterval(intervalId)
    //         }
    //     }

    // }, [timeDiff, dispatch])

    // Updated the SIP function to use async/await and added error handling - 15/10/24 - Dev Srini
    // useEffect(() => {
    //     let agentStatusInterval

    //     agentStatusInterval = setInterval(async () => {
    //         if (agentPublishStatus === 'open' && isLoggedIn) {

    //             try {
    //                 await window.sipPublish('open', 'Idle', 'I am Idle')
    //                 console.log("SIP status published successfully: 'Idle' - 'I am Idle'.")

    //                 dispatch({
    //                     type: 'SET_AGENT_PUBLISH_STATS',
    //                     payload: 'open'
    //                 })
    //             }
    //             catch (error) {
    //                 console.error('Failed to publish SIP status:', error)
    //             }
    //         }
    //         console.log(agentPublishStatus, "- Agent SIP publish status.",)
    //     }, 600 * 1000)

    //     return () => {
    //         if (agentStatusInterval) {
    //             clearInterval(agentStatusInterval)
    //         }
    //     }

    // }, [agentPublishStatus, isLoggedIn])
    // added isLoggedIn dependency - 19/09/24 - dev srini

    // Srini 07-01-25
    const toggleDrawer = (open) => (event) => {
        if (
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }
        setDrawerOpen(open);
    }

    return (
        <div>
            <AppBar elevation={0} style={{ background: 'linear-gradient(90.79deg, #260F0E -24.95%, #24183B 33.25%, #741515 96.46%)', }}>
                <Toolbar>
                    {/* rewritten - Srini 07-01-25 */}
                    <Grid container style={{ width: '100%', height: isSmallScreen && '70px' }} alignItems="center">
                        {/* Agent Name Section */}
                        <Grid item xs={isSmallScreen ? 10 : 7}>
                            <AgentName />
                        </Grid>

                        {/* Conditional Rendering for Franchisee and Others */}
                        {departmentName === 'Franchisee' ? (
                            <Grid
                                item
                                xs={isSmallScreen ? 1.5 : 5}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    alignItems: 'center',
                                }}
                            >
                                {/* Hamburger Menu for Small Screens */}
                                {isSmallScreen ? (
                                    <>
                                 
                                        <IconButton
                                            edge="end"
                                            color="inherit"
                                            aria-label="menu"
                                            onTouchStart={toggleDrawer(true)}
                                        >
                                            <MenuIcon style={{ color: '#FFF' }} />
                                        </IconButton>
                                        <Drawer
                                            anchor="right"
                                            open={drawerOpen}
                                            onClose={toggleDrawer(false)}
                                            PaperProps={{
                                                style: {
                                                    width: '50vw',
                                                    height: '100vh',
                                                    backgroundColor: '#0B1420',
                                                    color: '#FFF',
                                                },
                                            }}
                                        >
                                            <List style={{ padding: '20px' }}>
                                                
                                                <ListItem
                                                    button
                                                    onTouchStart={() => {
                                                        navigate('/franchiseDashboard');
                                                        setDrawerOpen(false);
                                                        setSelectMenu('dashboard')
                                                    }}
                                                    style={{
                                                        backgroundColor: selectMenu === 'dashboard' ? 'black' : 'transparent',
                                                        color: selectMenu === 'dashboard' ? 'yellow' : 'white',
                                                        transition: 'background-color 0.3s, color 0.3s',
                                                    }}
                                                >
                                                    <ListItemText
                                                        primary="Dashboard"
                                                        primaryTypographyProps={{
                                                            style: { fontFamily: 'cardiuma-M', fontSize: '18px', textAlign: 'center' },
                                                        }}
                                                    />
                                                </ListItem>
                                              
                                                <ListItem
                                                    button
                                                    onTouchStart={() => {
                                                        handleLogout(dispatch, navigate);
                                                        setDrawerOpen(false);
                                                        setSelectMenu('')
                                                    }}
                                                    style={{
                                                        backgroundColor: selectMenu === 'logout' ? 'black' : 'transparent',
                                                        color: selectMenu === 'logout' ? 'yellow' : 'white',
                                                        transition: 'background-color 0.3s, color 0.3s',
                                                    }}
                                                >
                                                    <ListItemText
                                                        primary="Logout"
                                                        primaryTypographyProps={{
                                                            style: { fontFamily: 'cardiuma-M', fontSize: '18px', textAlign: 'center' },
                                                        }}
                                                    />
                                                </ListItem>
                                            </List>
                                        </Drawer>
                                    </>
                                ) : (
                                    <SipStatus />
                                )}
                            </Grid>
                        ) : (
                            <Grid item xs={5}>
                                <SipStatus />
                            </Grid>
                        )}
                    </Grid>
                </Toolbar>
            </AppBar>
        </div>
    )
}

export default withStyles(styles)(Header)